import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Footer } from '../../components/Footer';
import { TransactionTracker } from '../../components/TransactionTracker';
import { ArrowLeft, Download, FileText, Calendar, User, Building } from 'lucide-react';
export function TransactionDetailPage() {
  const {
    id
  } = useParams();
  const transaction = {
    id: id || '1',
    plotTitle: 'Premium Corner Plot in Hinjewadi Phase 1',
    plotNumber: 'A-101',
    location: 'Hinjewadi, Pune',
    size: '2,400 Sq. Ft',
    agreedPrice: '₹45,00,000',
    buyer: 'Rohan Gupta',
    seller: 'Rajesh Kumar',
    status: 'documentation',
    startDate: '2024-01-15',
    estimatedCompletion: '2024-02-28'
  };
  const transactionSteps = [{
    id: 'offer',
    label: 'Offer Accepted',
    status: 'completed' as const,
    date: '2024-01-15'
  }, {
    id: 'agreement',
    label: 'Agreement Signed',
    status: 'completed' as const,
    date: '2024-01-18'
  }, {
    id: 'documentation',
    label: 'Documentation & Verification',
    status: 'current' as const,
    date: 'In Progress'
  }, {
    id: 'payment',
    label: 'Payment Processing',
    status: 'pending' as const
  }, {
    id: 'registration',
    label: 'Property Registration',
    status: 'pending' as const
  }, {
    id: 'handover',
    label: 'Handover & Completion',
    status: 'pending' as const
  }];
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-5881">
      {/* Header */}
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-5882">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-5883">
          <Link to="/" className="flex items-center gap-2" data-id="element-5884">
            <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-5885"></div>
            <span className="font-bold text-xl tracking-tight" data-id="element-5886">
              Citiplots.com
            </span>
          </Link>
        </div>
      </header>

      <main className="flex-1 max-w-6xl mx-auto px-6 py-12 w-full" data-id="element-5887">
        <Link to="/dashboard" className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-6" data-id="element-5888">
          <ArrowLeft className="w-4 h-4" data-id="element-5889" />
          Back to Dashboard
        </Link>

        <h1 className="text-3xl font-bold mb-2" data-id="element-5890">
          Transaction #{transaction.id}
        </h1>
        <p className="text-gray-500 font-mono text-sm mb-8" data-id="element-5891">
          Started {transaction.startDate} • Est. completion{' '}
          {transaction.estimatedCompletion}
        </p>

        {/* Transaction Details */}
        <div className="bg-white border border-gray-300 p-8 mb-8" data-id="element-5892">
          <h2 className="text-xl font-bold mb-6" data-id="element-5893">Property Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5894">
            <div className="flex items-start gap-3" data-id="element-5895">
              <Building className="w-5 h-5 text-gray-400 mt-1" data-id="element-5896" />
              <div data-id="element-5897">
                <div className="text-sm text-gray-500" data-id="element-5898">Property</div>
                <div className="font-bold" data-id="element-5899">{transaction.plotTitle}</div>
                <div className="text-sm text-gray-600" data-id="element-5900">
                  {transaction.location}
                </div>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-5901">
              <FileText className="w-5 h-5 text-gray-400 mt-1" data-id="element-5902" />
              <div data-id="element-5903">
                <div className="text-sm text-gray-500" data-id="element-5904">Plot Number</div>
                <div className="font-bold" data-id="element-5905">{transaction.plotNumber}</div>
                <div className="text-sm text-gray-600" data-id="element-5906">{transaction.size}</div>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-5907">
              <User className="w-5 h-5 text-gray-400 mt-1" data-id="element-5908" />
              <div data-id="element-5909">
                <div className="text-sm text-gray-500" data-id="element-5910">Buyer</div>
                <div className="font-bold" data-id="element-5911">{transaction.buyer}</div>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-5912">
              <User className="w-5 h-5 text-gray-400 mt-1" data-id="element-5913" />
              <div data-id="element-5914">
                <div className="text-sm text-gray-500" data-id="element-5915">Seller</div>
                <div className="font-bold" data-id="element-5916">{transaction.seller}</div>
              </div>
            </div>
          </div>

          <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-5917">
            <div className="flex items-center justify-between" data-id="element-5918">
              <div data-id="element-5919">
                <div className="text-sm text-gray-500" data-id="element-5920">Agreed Price</div>
                <div className="text-3xl font-bold" data-id="element-5921">
                  {transaction.agreedPrice}
                </div>
              </div>
              <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-5922">
                <Download className="w-4 h-4" data-id="element-5923" />
                Download Agreement
              </button>
            </div>
          </div>
        </div>

        {/* Transaction Progress */}
        <TransactionTracker steps={transactionSteps} data-id="element-5924" />

        {/* Documents */}
        <div className="bg-white border border-gray-300 p-8 mt-8" data-id="element-5925">
          <h2 className="text-xl font-bold mb-6" data-id="element-5926">Documents</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5927">
            {[{
            name: 'Sale Agreement',
            status: 'Signed',
            date: '2024-01-15'
          }, {
            name: 'Title Deed',
            status: 'Verified',
            date: '2024-01-18'
          }, {
            name: 'Tax Receipts',
            status: 'Pending',
            date: '-'
          }, {
            name: 'NOC Documents',
            status: 'In Progress',
            date: '-'
          }].map((doc, i) => <div key={i} className="p-4 border border-gray-200 bg-gray-50 flex items-center justify-between" data-id="element-5928">
                <div className="flex items-center gap-3" data-id="element-5929">
                  <FileText className="w-5 h-5 text-gray-400" data-id="element-5930" />
                  <div data-id="element-5931">
                    <div className="font-bold text-sm" data-id="element-5932">{doc.name}</div>
                    <div className="text-xs text-gray-500" data-id="element-5933">{doc.date}</div>
                  </div>
                </div>
                <span className={`px-2 py-1 text-xs font-bold rounded border ${doc.status === 'Signed' || doc.status === 'Verified' ? 'bg-green-100 text-green-800 border-green-200' : doc.status === 'In Progress' ? 'bg-blue-100 text-blue-800 border-blue-200' : 'bg-yellow-100 text-yellow-800 border-yellow-200'}`} data-id="element-5934">
                  {doc.status}
                </span>
              </div>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-5935" />
    </div>;
}